module.exports = (angularModule) => {
  angularModule.directive('configToggle', () => ({
    restrict: 'E',
    scope: {
      ngModel: '=',
      fieldName: '@',
      label: '@',
      description: '@'
    },
    template: `
    <div>
      <div
           class="btn btn-xs"
           ng-click="ngModel = !ngModel">
        <span
            class="{{
            'far fa-2x ' +
            (ngModel ? 'fa-toggle-on text-success' : 'fa-toggle-off')
            }}"></span>
      </div>
      <label
        uib-tooltip="{{description}}"
        ng-if="fieldName !== undefined">{{fieldName | camelCaseToHuman}}</label>
      <label
        uib-tooltip="{{description}}"
        ng-if="label !== undefined">{{label}}</label>
    </div>
`
  }))
}
